import { DefaultOverview, DefaultTopics } from "./DefaultViews";
export const CommonMyProfileOverview = () => {
    return <DefaultOverview />;
};
export const CommonMyProfileTopics = () => {
    return <DefaultTopics />;
};
